var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"FHbK4J4OAsLqmjUAVAbUt"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dapp@liveart"]={id:"FHbK4J4OAsLqmjUAVAbUt"};
      